import { Component, Input} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ParamData } from '../../models/param-data';
import { TreeViewDataBase } from '../../models/tree-view-data-base';

@Component({
    selector: 'display-param-grouped-treeview-data',
    styleUrls: ['./display-param-grouped-treeview-data.scss'],
    template: `
        <div class='border-bottom mb-1 pb-1'>
          <div class='display-param-grouped-tree-title border-bottom mb-2 p-1'>
            <p class='m-0'>{{paramTitle}}: </p>
          </div>
          @for (viewData of treeViewDatas; track viewData; let i = $index) {
            <div class="px-1">
              <div class='display-param-tree-name'>
                <p class='m-0'>&bull;&ensp; {{viewData.getParamPresentation().title}}</p>
              </div>
              <div class='display-param-tree-data mb-1' [innerHtml]='getDataOutput(viewData, paramDatas[i])'></div>
            </div>
          }
        </div>
        `,
        standalone: true
})
export class DisplayParamGroupedTreeViewDataComponent {
    @Input() paramTitle: string;
    @Input() paramDatas: ParamData[];
    @Input() treeViewDatas: TreeViewDataBase[];

    constructor(
        private translate: TranslateService
    ){}

    public getDataOutput(viewData: TreeViewDataBase, paramData: ParamData): string {
        let paramPresentation = viewData.getParamPresentation();
        let data = paramPresentation.getParamData();
        let output = '<div class="param-pres-wrapper">';

        if (!paramData.data || paramData.data.length === 0)
            output += '<i>'+ this.translate.instant('urval.my-selections.options.none') +'</i>';
        else if (paramData.data.length == 1 && data.length == 1)
            output += '<span>'+ this.translate.instant('urval.my-selections.options.yes') +'</span>';
        else if (paramData.data.length == data.length)
            output += '<span>'+ this.translate.instant('urval.my-selections.options.all') +'</span>';
        else
            output += paramPresentation.getParamDataOutput(paramData);

        output += '</div>';
        return output;
    }

}
